import {
    ValidationProvider,
    extend,
    setInteractionMode,
    ValidationObserver
} from 'vee-validate';

import {
    required,
    email,
    oneOf,
    min,
    max,
    integer,
    min_value,
    max_value,
    required_if
} from 'vee-validate/dist/rules';

const moment = require('moment');
const regexParser = require('regex-parser');

export function setupValidation(Vue) {

    Vue.component('ValidationProvider', ValidationProvider);
    Vue.component('ValidationObserver', ValidationObserver);

    setInteractionMode('eager');
    extend('required', required);
    extend('required_if', required_if);
    extend('in', oneOf);
    extend('email', email);
    extend('min', min);
    extend('max', max);
    extend('integer', integer);
    extend('min_value', min_value);
    extend('max_value', max_value);

    extend('date_format', {
        validate(value, {
            format
        }) {
            return (moment(value, format, true).isValid());
        },
        getMessage(field, args) {
            return '{_field_} should be in format {format}';
        },
        params: ['format']
    });

    extend('regex', {
        validate(value, {
            pattern
        }) {
            if (!pattern) {
                console.log('No pattern supplied for regex validator');
                return true;
            }
            if (typeof pattern === 'string') {
                pattern = regexParser(pattern);
            }
            if (!pattern.test) {
                return true;
            }
            return pattern.test(value);
        },
        getMessage(field, args) {
            return '{_field_} should be in format {pattern}';
        },
        params: ['pattern']
    });

    extend('before', {
        validate(value, {
            max
        }) {
            return moment(value, null, true).isBefore(moment(max, moment.HTML5_FMT.DATE));
        },
        getMessage(field, args) {
            return '{_field_} should be before { min }';
        },
        params: ['max']
    });

    extend('after', {
        validate: (value, args) => {
            return moment(value, null, true).isAfter(moment(args.min, moment.HTML5_FMT.DATE));
        },
        getMessage: (field, args) => {
            return '{_field_} should be after { min }';
        },
        params: ['min'],
    }, ['min']);
}